import { apiClient, unwrapV2Response } from './index.js';

export const getMaptilerKey = async projectUuid => {
	const { data, error } = await apiClient.get(`/v2/maptiler/${projectUuid}/key`);

	if (error) {
		throw new Error(error.message || 'Failed to fetch MapTiler key');
	}

	const key = unwrapV2Response(data)?.api_key;
	if (!key) throw new Error('MapTiler API key not found in response');
	return key;
};
